import * as ol from 'openlayers'
import BasePointAspect from './BasePointAspect'
import { translate } from '@/translation/native_translate.js';

export default class UserAspect extends BasePointAspect {

  constructor(data) {
    super(data);
    this.setProperties(data);
    this.setZIndex(11);
  }

  setProperties(data) {
    super.setProperties(data);
    this.set('timestamp', Number(data.dataFieldTable.dateTime));
    this.set('customerGroup', data.customerGroup);
    this.set('userCategory', data.userCategory);
    this.set('userName', data.dataFieldTable.userName);
  }

  createStyle() {
    return [
      new ol.style.Style({
        image: new ol.style.Icon( /* @type {olx.style.IconOptions} */ ({
          anchorXUnits: 'fraction',
          anchorYUnits: 'fraction',
          src: this.getImagePath("user/", "official", '.svg'),
          anchor: [0.5, 0.5],
        }))
      })
    ];
  }

  createTooltip() {
    let ts = new Date(this.get('timestamp') * 1000);

    let text = "<div id='map-popup-tooltip'>";
    text += "<p class='pop-up-atribute' >Naam: " + this.get('userName') + "</p>";
    text += "<p class='pop-up-atribute' >Timestamp: " + ts.toLocaleString() + "</p>";
    text += "<p class='pop-up-atribute' >CustomerGroup: " + this.get('customerGroup') + "</p>";
    text += "</div>";
    return text;
  }
}
